import type { StreamTaskStatusTarget } from './handle-stream-task-status';
import type { UnifiedTasksContainerDep } from './types';

/** Builds a {@link StreamTaskStatusTarget} from the unified-tasks container dep. */
export const buildUnifiedStreamTaskTarget = (
	unifiedTasksActions: UnifiedTasksContainerDep,
): StreamTaskStatusTarget => ({
	createTaskFromStream: (args) => unifiedTasksActions.createTaskFromStream(args),
	setTaskProgressState: (args) => unifiedTasksActions.setTaskProgressState(args),
});
